<!--
Map screen
@author bmk11u, crm4f
-->
<template>
  <div id="contain" class="container">
    <Nav name="Map" v-bind:home="true" v-if="authenticated"/>
    <Nav name="Map" v-if="!authenticated"/>

    <CampusMap
      :pan-target="destination ? stringLatLngToNumberLatLng(destination.entrance.latLng) : null"
      :google-api-promise="googleApiPromise"
      :locationName="locationName"
      :roomToRoom="roomToRoom"
      :accessUrl="accessUrl"
    >
      <OriginDestinationMarkers :destination="destination"/>
    </CampusMap>

    <div id="pusher"></div>

    <Footer active="notifications" v-if="authenticated"/>
  </div>
</template>

<script setup>
import CopyComplete from '@/components/CopyComplete.vue'
import ClipboardJS from 'clipboard'
import Footer from '@/components/FooterMenu.vue'
import {useLocationsCommon} from '@/composables/LocationsCommon.js'
import {useMapCommon} from '@/composables/MapCommon.js'
import {useGeoCommon} from '@/composables/GeoCommon.js'
import {onMounted, ref} from 'vue'
import {useRoute} from 'vue-router'
import CampusMap from "@/components/map/CampusMap.vue";
import OriginDestinationMarkers from "@/components/map/OriginDestinationMarkers.vue";


const destination = ref(null)
const roomToRoom = ref(false)
const accessUrl = ref(null)
const locationName = ref(null)

const route = useRoute()

const {authenticated} = useLocationsCommon()
const {geoLatitude, geoLongitude, geoLocationAvailable} = useGeoCommon()

const {
  stringLatLngToNumberLatLng,
  fetchLocation,
  googleApiPromise
} = useMapCommon()

onMounted(() => {

  fetchDestination()
})

async function fetchDestination() {
  destination.value = await fetchLocation(route.query.toId);

  roomToRoom.value = destination.value.roomToRoom;
  accessUrl.value = destination.value.accessUrl;
  locationName.value = destination.value.locationName
}

function goOut(url) {
  window.open(url)
}
</script>

<style scoped>
.copyLink {
  background-color: var(--uog-dark-blue);
  color: #ffffff;
  border: 1px solid var(--uog-dark-blue);
  border-radius: 12px;
  height: 36px;
  font-weight: 700;
  font-family: PTSans;
  margin-left: 12px;
}

.accessableLink {
  background-color: #ffffff;
  color: var(--uog-dark-blue);
  border: 1px solid var(--uog-dark-blue);
  border-radius: 12px;
  height: 36px;
  font-weight: 700;
  font-family: PTSans;
  margin-left: 12px;
}
</style>
